import * as React from "react";
import { motion, useTransform } from "framer-motion";
import { useSheetContext } from "./context";
import styles from "./styles";
const SheetHeader = React.forwardRef(({ children, style, disableDrag, ...rest }, ref) => {
    const { indicatorRotation, dragProps } = useSheetContext();
    const _dragProps = disableDrag ? undefined : dragProps;
    const indicator1Transform = useTransform(indicatorRotation, (r) => `translateX(2px) rotate(${r}deg)`);
    const indicator2Transform = useTransform(indicatorRotation, (r) => `translateX(-2px) rotate(${-1 * r}deg)`);
    return (React.createElement(motion.div, { ...rest, ref: ref, style: { ...styles.headerWrapper, ...style }, ..._dragProps }, children || (React.createElement("div", { className: "react-modal-sheet-header", style: styles.header },
        React.createElement(motion.span, { className: "react-modal-sheet-drag-indicator", style: { ...styles.indicator, transform: indicator1Transform } }),
        React.createElement(motion.span, { className: "react-modal-sheet-drag-indicator", style: { ...styles.indicator, transform: indicator2Transform } })))));
});
SheetHeader.displayName = "SheetHeader";
export default SheetHeader;
//# sourceMappingURL=sheet-header.js.map